/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconArrowDown/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaIconArrowDown({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconArrowDown",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconArrowDown.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-G7iWH': alignSelf,'--mt-2-G7iWH': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-G7iWH': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-G7iWH': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-G7iWH': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-G7iWH': opacity,'--w-10-G7iWH': typeof width === 'number' ? `${width}px` : width,'--h-11-G7iWH': typeof height === 'number' ? `${height}px` : height,'--f-12-G7iWH': fill,'--a-7-G7iWH': isAnimated ? animation : "none",'--sd-8-G7iWH': isAnimated ? strokeDashoffset : 0,'--sd-9-G7iWH': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="TysiaIconArrowDown.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_1551_17200)"
 className="views-block"
>
<path
  data-testid="TysiaIconArrowDown.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2.293 5.793a1 1 0 000 1.414l5.646 5.647a1.5 1.5 0 002.122 0l5.646-5.647a1 1 0 00-1.414-1.414L9 11.086 3.707 5.793a1 1 0 00-1.414 0z"
 style={{'--f-12-G7iWH': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}